import { IonNote } from '@ionic/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectPlayerShipType } from '../../../store/game/ship/ship.selectors';

export const PlayerShipTypeMenuLabel: React.FC = () => {
  const playerShipType = useSelector(selectPlayerShipType);
  return (
    <IonNote slot="end" className="ion-text-uppercase">
      {playerShipType}
    </IonNote>
  );
};
